
import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { contextProvider } from "../../../../context/ContextProvider";
import Alerts from "../../../components/Alerts/Alerts";
import RestPrivateAntesala from "../../../../helpers/RestPrivateApi";

const MapaTeatro = ({ setForm, form, setValidation, validation }) => {
  const context = useContext(contextProvider);
  const canvasRef = useRef(null);
  const [ctx, setCtx] = useState(null);

  console.log(form)

  // Callback ref para inicializar el canvas inmediatamente cuando se monta
  const canvasCallbackRef = useCallback((canvas) => {
    console.log("canvasCallbackRef ejecutado", canvas);

    if (canvas) {
      canvasRef.current = canvas;
      const context = canvas.getContext("2d");

      console.log("Canvas montado, obteniendo contexto:", context);

      // Ajustar tamaño (mismo que vista pública)
      canvas.width = 800;
      canvas.height = 600;

      // Dibujar fondo inmediatamente
      context.fillStyle = "#FFFFFF";
      context.fillRect(0, 0, canvas.width, canvas.height);

      // Grid (28px = tamaño de los asientos)
      context.strokeStyle = "#f0f0f0";
      context.lineWidth = 0.5;
      for (let x = 0; x < canvas.width; x += 28) {
        context.beginPath();
        context.moveTo(x, 0);
        context.lineTo(x, canvas.height);
        context.stroke();
      }
      for (let y = 0; y < canvas.height; y += 28) {
        context.beginPath();
        context.moveTo(0, y);
        context.lineTo(canvas.width, y);
        context.stroke();
      }

      // Escenario
      context.save();
      context.fillStyle = "#2C3E50";
      context.strokeStyle = "#34495E";
      context.lineWidth = 3;
      context.beginPath();
      context.arc(550, 110, 150, Math.PI, 0, false);
      context.closePath();
      context.fill();
      context.stroke();
      context.fillStyle = "#FFFFFF";
      context.font = "bold 16px Arial";
      context.textAlign = "center";
      context.fillText("ESCENARIO", 550, 80);
      context.restore();

      // Texto
      context.fillStyle = "#666666";
      context.font = "16px Arial";
      context.textAlign = "center";
      context.fillText("Haz click en 'Generar' en un sector para crear asientos", canvas.width / 2, canvas.height / 2);

      console.log("Canvas dibujado, estableciendo contexto en estado");
      setCtx(context);
    }
  }, []);

  // Constantes del editor
  const GRID_SIZE = 28; // Tamaño de la cuadrícula (coincide con el tamaño del asiento)

  // Estados del editor
  const [herramientaActiva, setHerramientaActiva] = useState("seleccionar");
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [asientoArrastrado, setAsientoArrastrado] = useState(null);
  const [offsetAsiento, setOffsetAsiento] = useState({ x: 0, y: 0 });
  const [escenarioArrastrado, setEscenarioArrastrado] = useState(false);
  const [offsetEscenario, setOffsetEscenario] = useState({ x: 0, y: 0 });
  const [elementoEspecialArrastrado, setElementoEspecialArrastrado] = useState(null);
  const [offsetElementoEspecial, setOffsetElementoEspecial] = useState({ x: 0, y: 0 });
  const [snapToGrid, setSnapToGrid] = useState(true); // Activar snap to grid por defecto

  // Estados del mapa
  const [sectores, setSectores] = useState([]);
  const [asientos, setAsientos] = useState([]);
  const [escenario, setEscenario] = useState({
    x: 400,
    y: 50,
    width: 300,
    height: 60,
    tipo: "semicircular"
  });
  const [elementosEspeciales, setElementosEspeciales] = useState([]); // Escaleras, salidas, etc.

  // Estados de selección
  const [elementoSeleccionado, setElementoSeleccionado] = useState(null);
  const [tipoSeleccionado, setTipoSeleccionado] = useState(null); // 'asiento' | 'sector' | 'escenario' | 'especial'
  const [elementoEspecialAAgregar, setElementoEspecialAAgregar] = useState(null); // Tipo de elemento a agregar
  const [asientosSeleccionados, setAsientosSeleccionados] = useState([]); // Array de IDs de asientos seleccionados
  const [modoSeleccionMultiple, setModoSeleccionMultiple] = useState(false);

  // Plantillas de disposición
  const [plantillaActiva, setPlantillaActiva] = useState("principal");
  const [mostrarModalGenerador, setMostrarModalGenerador] = useState(false);
  const [sectorGenerando, setSectorGenerando] = useState(null);
  const [mostrarModalOrganizar, setMostrarModalOrganizar] = useState(false);
  const [sectorOrganizando, setSectorOrganizando] = useState(null);
  const [formaOrganizacion, setFormaOrganizacion] = useState("cuadrado");
  const [loadingSave, setLoadingSave] = useState(false);

  // Configuración del generador de asientos
  const [configGenerador, setConfigGenerador] = useState({
    filas: 10,
    asientosPorFila: 15,
    espacioHorizontal: 35,
    espacioVertical: 35,
    curvatura: 0, // 0-100
    offsetInicio: 0,
    numeracionFila: "A",
    numeracionInicio: 1,
    rotacion: 0
  });

  // Estado para controlar si ya se cargaron los datos de site_maps
  const [siteMapsCargados, setSiteMapsCargados] = useState(false);
  const [siteMapId, setSiteMapId] = useState(null);

  // Cargar datos de site_maps desde el evento (solo una vez)
  useEffect(() => {
    if (form.site_maps && Array.isArray(form.site_maps) && form.site_maps.length > 0 && !siteMapsCargados) {
      const siteMapData = form.site_maps[0];

      console.log("Cargando site_maps desde el evento:", siteMapData);

      // Guardar el ID del site_map para futuras actualizaciones
      if (siteMapData.id) {
        setSiteMapId(siteMapData.id);
        console.log("ID de site_map guardado:", siteMapData.id);
      }

      // Parsear site_map si viene como string
      let parsedSiteMap = siteMapData.site_map;
      if (typeof parsedSiteMap === 'string') {
        try {
          parsedSiteMap = JSON.parse(parsedSiteMap);
          console.log("site_map parseado correctamente:", parsedSiteMap);
        } catch (e) {
          console.error("Error al parsear site_map:", e);
          return;
        }
      }

      // Cargar asientos
      if (parsedSiteMap.asientos && parsedSiteMap.asientos.length > 0) {
        console.log("Cargando asientos desde site_maps:", parsedSiteMap.asientos.length);
        setAsientos(parsedSiteMap.asientos);
      }

      // Cargar escenario
      if (parsedSiteMap.escenario) {
        console.log("Cargando escenario desde site_maps");
        setEscenario(parsedSiteMap.escenario);
      }

      // Cargar elementos especiales
      if (parsedSiteMap.elementosEspeciales && parsedSiteMap.elementosEspeciales.length > 0) {
        console.log("Cargando elementos especiales desde site_maps:", parsedSiteMap.elementosEspeciales.length);
        setElementosEspeciales(parsedSiteMap.elementosEspeciales);
      } else {
        console.log("No hay elementos especiales en site_maps");
        setElementosEspeciales([]);
      }

      // Marcar como cargado
      setSiteMapsCargados(true);

      console.log("Datos de site_maps cargados exitosamente");
    }
  }, [form.site_maps, siteMapsCargados]);

  // Extraer sectores de las entradas
  useEffect(() => {
    console.log("Procesando entradas para sectores:", form.entradas[0]);

    const sectoresDesdeEntradas = form.entradas[0]
      .filter(entrada => entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "")
      .map((entrada, index) => ({
        id: entrada.id[0] || `temp_${index}`,
        entrada_id: entrada.id[0],
        nombre: entrada.sector[0],
        tipo_entrada: entrada.nombre[0],
        capacidad: parseInt(entrada.stock[0]) || 0,
        precio: parseFloat(entrada.precio[0]) || 0,
        color: generarColorPorIndice(index),
        visible: true
      }));

    console.log("Sectores extraídos:", sectoresDesdeEntradas);

    setSectores(sectoresDesdeEntradas);

    // Solo cargar asientos desde mapa_teatro si NO se cargaron desde site_maps
    if (!siteMapsCargados) {
      if (!form.site_maps || form.site_maps.length === 0) {
        if (form.mapa_teatro && form.mapa_teatro[0] && form.mapa_teatro[0].asientos && form.mapa_teatro[0].asientos.length > 0) {
          console.log("Cargando asientos guardados desde mapa_teatro:", form.mapa_teatro[0].asientos.length);
          setAsientos(form.mapa_teatro[0].asientos);
        } else {
          console.log("No hay asientos guardados en el formulario");
          // No limpiar asientos si ya se cargaron de site_maps
        }

        if (form.mapa_teatro && form.mapa_teatro[0] && form.mapa_teatro[0].escenario) {
          console.log("Cargando escenario guardado desde mapa_teatro");
          setEscenario(form.mapa_teatro[0].escenario);
        }

        if (form.mapa_teatro && form.mapa_teatro[0] && form.mapa_teatro[0].elementosEspeciales) {
          console.log("Cargando elementos especiales guardados desde mapa_teatro:", form.mapa_teatro[0].elementosEspeciales.length);
          setElementosEspeciales(form.mapa_teatro[0].elementosEspeciales);
        }
      }
    }
  }, [form.entradas, siteMapsCargados]);

  const generarColorPorIndice = (index) => {
    const colores = [
      "#5B9BD5", // Azul VIP
      "#70AD47", // Verde Preferencia
      "#FFC000", // Naranja General
      "#ED7D31", // Naranja oscuro
      "#A5A5A5", // Gris
      "#4472C4", // Azul oscuro
      "#9E480E", // Marrón
      "#636363"  // Gris oscuro
    ];
    return colores[index % colores.length];
  };

  // Función para ajustar posición al grid (snap to grid)
  const snapPositionToGrid = (x, y) => {
    if (!snapToGrid) return { x, y };

    return {
      x: Math.round(x / GRID_SIZE) * GRID_SIZE,
      y: Math.round(y / GRID_SIZE) * GRID_SIZE
    };
  };

  // Función de renderizado principal (DEBE estar ANTES de los useEffect que la usan)
  const dibujarMapa = useCallback(() => {
    if (!ctx || !canvasRef.current) {
      console.log("No se puede dibujar: ctx o canvas no disponible", { ctx, canvas: canvasRef.current });
      return;
    }

    const canvas = canvasRef.current;

    console.log("Dibujando mapa:", {
      asientos: asientos.length,
      sectores: sectores.length,
      zoom,
      offset,
      canvasWidth: canvas.width,
      canvasHeight: canvas.height
    });

    try {
      // Limpiar canvas con fondo blanco
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Dibujar grid de fondo mejorado (con líneas principales y secundarias)
      if (snapToGrid) {
        // Líneas secundarias (cada celda del grid)
        ctx.strokeStyle = "#E8E8E8";
        ctx.lineWidth = 0.5;
        for (let x = 0; x < canvas.width; x += GRID_SIZE) {
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x, canvas.height);
          ctx.stroke();
        }
        for (let y = 0; y < canvas.height; y += GRID_SIZE) {
          ctx.beginPath();
          ctx.moveTo(0, y);
          ctx.lineTo(canvas.width, y);
          ctx.stroke();
        }

        // Líneas principales (cada 5 celdas - 140px)
        ctx.strokeStyle = "#CCCCCC";
        ctx.lineWidth = 1;
        for (let x = 0; x < canvas.width; x += GRID_SIZE * 5) {
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x, canvas.height);
          ctx.stroke();
        }
        for (let y = 0; y < canvas.height; y += GRID_SIZE * 5) {
          ctx.beginPath();
          ctx.moveTo(0, y);
          ctx.lineTo(canvas.width, y);
          ctx.stroke();
        }

        // Puntos de intersección para mejor visualización
        ctx.fillStyle = "#D0D0D0";
        for (let x = 0; x < canvas.width; x += GRID_SIZE) {
          for (let y = 0; y < canvas.height; y += GRID_SIZE) {
            ctx.beginPath();
            ctx.arc(x, y, 1, 0, Math.PI * 2);
            ctx.fill();
          }
        }
      } else {
        // Grid simple cuando snap está desactivado
        ctx.strokeStyle = "#f5f5f5";
        ctx.lineWidth = 0.5;
        for (let x = 0; x < canvas.width; x += GRID_SIZE) {
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x, canvas.height);
          ctx.stroke();
        }
        for (let y = 0; y < canvas.height; y += GRID_SIZE) {
          ctx.beginPath();
          ctx.moveTo(0, y);
          ctx.lineTo(canvas.width, y);
          ctx.stroke();
        }
      }

      ctx.save();
      ctx.translate(offset.x, offset.y);
      ctx.scale(zoom, zoom);

      // Dibujar escenario
      if (escenario) {
        ctx.save();

        // Si el escenario está siendo arrastrado, aplicar sombra
        if (escenarioArrastrado) {
          ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
          ctx.shadowBlur = 15;
          ctx.shadowOffsetX = 5;
          ctx.shadowOffsetY = 5;
        }

        ctx.fillStyle = "#2C3E50";
        ctx.strokeStyle = "#34495E";
        ctx.lineWidth = 3;

        if (escenario.tipo === "semicircular") {
          ctx.beginPath();
          ctx.arc(
            escenario.x + escenario.width / 2,
            escenario.y + escenario.height,
            escenario.width / 2,
            Math.PI,
            0,
            false
          );
          ctx.closePath();
          ctx.fill();
          ctx.stroke();
        } else {
          ctx.fillRect(escenario.x, escenario.y, escenario.width, escenario.height);
          ctx.strokeRect(escenario.x, escenario.y, escenario.width, escenario.height);
        }

        // Resetear sombra
        ctx.shadowColor = "transparent";
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;

        ctx.fillStyle = "#FFFFFF";
        ctx.font = "bold 16px Arial";
        ctx.textAlign = "center";
        ctx.fillText("ESCENARIO", escenario.x + escenario.width / 2, escenario.y + escenario.height / 2);

        if (tipoSeleccionado === 'escenario') {
          ctx.strokeStyle = "#3498db";
          ctx.lineWidth = 3;
          ctx.setLineDash([5, 5]);
          ctx.strokeRect(escenario.x - 5, escenario.y - 5, escenario.width + 10, escenario.height + 10);
          ctx.setLineDash([]);
        }

        ctx.restore();
      }

      // Dibujar asientos
      if (asientos && asientos.length > 0) {
        console.log("Dibujando", asientos.length, "asientos");
        console.log("Sectores disponibles:", sectores);
        asientos.forEach((asiento, index) => {
          if (index === 0) {
            console.log("Primer asiento a dibujar:", asiento);
            console.log("Buscando sector con id:", asiento.sector_id);
          }

          // Comparar sector_id considerando que puede ser número o string
          const sector = sectores.find(s => s.id == asiento.sector_id || s.entrada_id == asiento.sector_id);
          if (!sector) {
            if (index === 0) console.log("Sector no encontrado para asiento:", asiento, "Sectores:", sectores);
            return;
          }
          if (!sector.visible) {
            if (index === 0) console.log("Sector no visible:", sector);
            return;
          }

          ctx.save();

          let color = sector.color;
          if (asiento.estado === "reservado") color = "#FFA500";
          if (asiento.estado === "vendido") color = "#DC3545";
          if (asiento.estado === "bloqueado") color = "#6C757D";

          ctx.fillStyle = color;
          ctx.strokeStyle = "#FFFFFF";
          ctx.lineWidth = 1.5;

          // Si este asiento está siendo arrastrado, dibujarlo con efecto de sombra
          if (asientoArrastrado && asientoArrastrado.id === asiento.id) {
            ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
            ctx.shadowBlur = 10;
            ctx.shadowOffsetX = 5;
            ctx.shadowOffsetY = 5;
          }

          if (asiento.tipo === "accesible") {
            // Asiento accesible con símbolo de silla de ruedas
            ctx.fillRect(asiento.x - 2, asiento.y - 2, asiento.width + 4, asiento.height + 4);
            ctx.strokeRect(asiento.x - 2, asiento.y - 2, asiento.width + 4, asiento.height + 4);
            ctx.fillStyle = "#FFFFFF";
            ctx.font = "12px Arial";
            ctx.textAlign = "center";
            ctx.fillText("♿", asiento.x + asiento.width / 2, asiento.y + asiento.height / 2 + 4);
          } else {
            // Diseño de butaca de teatro estilo imagen
            const w = asiento.width;
            const h = asiento.height;
            const x = asiento.x;
            const y = asiento.y;

            // Respaldo (parte superior más ancha)
            ctx.beginPath();
            ctx.moveTo(x + 2, y);
            ctx.lineTo(x + w - 2, y);
            ctx.arcTo(x + w, y, x + w, y + 2, 2);
            ctx.lineTo(x + w, y + h * 0.6);
            ctx.lineTo(x + w - 3, y + h * 0.6);
            ctx.lineTo(x + w - 3, y + 2);
            ctx.arcTo(x + w - 3, y, x + w - 5, y, 2);
            ctx.lineTo(x + 5, y);
            ctx.arcTo(x + 3, y, x + 3, y + 2, 2);
            ctx.lineTo(x + 3, y + h * 0.6);
            ctx.lineTo(x, y + h * 0.6);
            ctx.lineTo(x, y + 2);
            ctx.arcTo(x, y, x + 2, y, 2);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();

            // Asiento (base inferior redondeada)
            ctx.beginPath();
            ctx.moveTo(x + 2, y + h * 0.55);
            ctx.lineTo(x + w - 2, y + h * 0.55);
            ctx.lineTo(x + w - 2, y + h - 4);
            ctx.arcTo(x + w - 2, y + h, x + w - 6, y + h, 4);
            ctx.lineTo(x + 6, y + h);
            ctx.arcTo(x + 2, y + h, x + 2, y + h - 4, 4);
            ctx.closePath();

            // Efecto de profundidad en la base
            const gradient = ctx.createLinearGradient(x, y + h * 0.55, x, y + h);
            const baseColor = color;
            gradient.addColorStop(0, baseColor);
            gradient.addColorStop(1, shadeColor(baseColor, -20));
            ctx.fillStyle = gradient;
            ctx.fill();
            ctx.strokeStyle = color;
            ctx.lineWidth = 1;
            ctx.stroke();

            // Número del asiento
            ctx.fillStyle = "#FFFFFF";
            ctx.font = "bold 9px Arial";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(asiento.numero, x + w / 2, y + h * 0.80);
          }

          // Función auxiliar para oscurecer/aclarar colores
          function shadeColor(color, percent) {
            const num = parseInt(color.replace("#", ""), 16);
            const amt = Math.round(2.55 * percent);
            const R = (num >> 16) + amt;
            const G = (num >> 8 & 0x00FF) + amt;
            const B = (num & 0x0000FF) + amt;
            return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
              (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
              (B < 255 ? B < 1 ? 0 : B : 255))
              .toString(16).slice(1);
          }

          // Resetear sombra
          ctx.shadowColor = "transparent";
          ctx.shadowBlur = 0;
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;

          // Si está seleccionado individualmente
          if (elementoSeleccionado && elementoSeleccionado.id === asiento.id && tipoSeleccionado === 'asiento') {
            ctx.strokeStyle = "#3498db";
            ctx.lineWidth = 3;
            ctx.setLineDash([3, 3]);
            ctx.strokeRect(asiento.x - 3, asiento.y - 3, asiento.width + 6, asiento.height + 6);
            ctx.setLineDash([]);
          }

          // Si está en la selección múltiple
          if (asientosSeleccionados.includes(asiento.id)) {
            ctx.strokeStyle = "#28a745";
            ctx.lineWidth = 3;
            ctx.setLineDash([3, 3]);
            ctx.strokeRect(asiento.x - 3, asiento.y - 3, asiento.width + 6, asiento.height + 6);
            ctx.setLineDash([]);
          }

          ctx.restore();
        });
        console.log("Asientos dibujados correctamente");
      } else {
        console.log("No hay asientos para dibujar");
      }

      // Dibujar elementos especiales (escaleras, salidas, etc.)
      if (elementosEspeciales && elementosEspeciales.length > 0) {
        elementosEspeciales.forEach(elemento => {
          ctx.save();

          // Colores según tipo
          let color = "#666666";
          switch (elemento.tipo) {
            case "escalera":
              color = "#95A5A6";
              break;
            case "ingreso":
              color = "#27AE60";
              break;
            case "salida_emergencia":
              color = "#E74C3C";
              break;
            case "baño":
              color = "#3498DB";
              break;
            case "pasillo":
              color = "#BDC3C7";
              break;
            default:
              color = "#7F8C8D";
          }

          ctx.fillStyle = color;
          ctx.strokeStyle = "#34495E";
          ctx.lineWidth = 2;

          // Dibujar rectángulo
          ctx.fillRect(elemento.x, elemento.y, elemento.width, elemento.height);
          ctx.strokeRect(elemento.x, elemento.y, elemento.width, elemento.height);

          // Calcular tamaño de fuente dinámico según el tamaño del elemento
          // Con padding de 10px en cada lado
          const padding = 10;
          const maxWidth = elemento.width - (padding * 2);
          const maxHeight = elemento.height - (padding * 2);

          // Texto a mostrar
          const texto = elemento.etiqueta || elemento.tipo.replace('_', ' ');

          // Calcular tamaño de fuente que quepa en el rectángulo
          let fontSize = Math.min(maxHeight * 0.8, maxWidth / (texto.length * 0.6));
          fontSize = Math.max(8, Math.min(fontSize, 20)); // Min 8px, Max 20px

          // Dibujar texto centrado
          ctx.fillStyle = "#FFFFFF";
          ctx.font = `bold ${fontSize}px Arial`;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";

          // Dividir texto en múltiples líneas si es necesario
          const palabras = texto.split(' ');
          const lineas = [];
          let lineaActual = '';

          palabras.forEach(palabra => {
            const testLinea = lineaActual + (lineaActual ? ' ' : '') + palabra;
            const metrics = ctx.measureText(testLinea);

            if (metrics.width > maxWidth && lineaActual) {
              lineas.push(lineaActual);
              lineaActual = palabra;
            } else {
              lineaActual = testLinea;
            }
          });
          if (lineaActual) lineas.push(lineaActual);

          // Dibujar cada línea centrada verticalmente
          const lineHeight = fontSize * 1.2;
          const totalHeight = lineas.length * lineHeight;
          const startY = elemento.y + (elemento.height - totalHeight) / 2 + lineHeight / 2;

          lineas.forEach((linea, index) => {
            ctx.fillText(
              linea,
              elemento.x + elemento.width / 2,
              startY + (index * lineHeight)
            );
          });

          // Si está seleccionado
          if (elementoSeleccionado && elementoSeleccionado.id === elemento.id && tipoSeleccionado === 'especial') {
            ctx.strokeStyle = "#3498db";
            ctx.lineWidth = 3;
            ctx.setLineDash([5, 5]);
            ctx.strokeRect(elemento.x - 5, elemento.y - 5, elemento.width + 10, elemento.height + 10);
            ctx.setLineDash([]);
          }

          ctx.restore();
        });
      }

      ctx.restore();

      // Dibujar UI overlay (indicador de zoom)
      ctx.save();
      ctx.fillStyle = "rgba(0, 0, 0, 0.7)";
      ctx.fillRect(10, canvas.height - 40, 80, 30);
      ctx.fillStyle = "#FFFFFF";
      ctx.font = "14px Arial";
      ctx.textAlign = "left";
      ctx.fillText(`Zoom: ${Math.round(zoom * 100)}%`, 20, canvas.height - 20);
      ctx.restore();

      // Texto de ayuda si no hay asientos
      if (!asientos || asientos.length === 0) {
        ctx.save();
        ctx.fillStyle = "#999999";
        ctx.font = "16px Arial";
        ctx.textAlign = "center";
        ctx.fillText("Haz click en 'Generar' en un sector para crear asientos", canvas.width / 2, canvas.height / 2 + 50);
        ctx.restore();
      }

      console.log("Mapa dibujado exitosamente");
    } catch (error) {
      console.error("Error al dibujar el mapa:", error);
    }
  }, [ctx, asientos, escenario, zoom, offset, elementoSeleccionado, tipoSeleccionado, sectores, asientoArrastrado, escenarioArrastrado, elementosEspeciales, elementoEspecialArrastrado, asientosSeleccionados, snapToGrid]);

  // Dibujar en canvas cada vez que cambian los datos
  useEffect(() => {
    if (ctx && canvasRef.current) {
      console.log("UseEffect de dibujo disparado");
      dibujarMapa();
    }
  }, [ctx, asientos, escenario, zoom, offset, elementoSeleccionado, sectores, dibujarMapa]);

  // Forzar redibujado cuando cambian los asientos
  useEffect(() => {
    if (ctx && canvasRef.current && asientos.length > 0) {
      console.log("Redibujando por cambio de asientos:", asientos.length);
      dibujarMapa();
    }
  }, [asientos.length, dibujarMapa]);

  // Forzar redibujado al establecer el contexto
  useEffect(() => {
    if (ctx) {
      console.log("Contexto establecido, forzando primer dibujo");
      setTimeout(() => {
        dibujarMapa();
      }, 100);
    }
  }, [ctx, dibujarMapa]);

  // Redibujar cuando se cargan los asientos desde site_maps
  useEffect(() => {
    if (ctx && siteMapsCargados && asientos.length > 0) {
      console.log("Asientos cargados desde site_maps, redibujando mapa...");
      setTimeout(() => {
        dibujarMapa();
      }, 200);
    }
  }, [siteMapsCargados, asientos.length, ctx, dibujarMapa]);

  // Generar asientos automáticamente para un sector
  const generarAsientosParaSector = (sectorId) => {
    const sector = sectores.find(s => s.id === sectorId);
    if (!sector) {
      console.error("Sector no encontrado:", sectorId);
      return;
    }

    console.log("Generando asientos para sector:", sector);
    console.log("Configuración:", configGenerador);

    const nuevosAsientos = [];
    const letraInicio = configGenerador.numeracionFila.charCodeAt(0);
    let numeroAsiento = configGenerador.numeracionInicio;
    let totalGenerados = 0;

    // Calcular posición base diferente para cada sector para evitar superposiciones
    const sectorIndex = sectores.findIndex(s => s.id === sectorId);
    const sectoresYaGenerados = asientos.filter(a => a.sector_id !== sectorId).map(a => a.sector_id);
    const sectoresUnicos = [...new Set(sectoresYaGenerados)];

    // Distribuir sectores en diferentes posiciones alineadas al grid
    const espacioEntreSectores = GRID_SIZE * 4; // 112px (4 celdas de separación)
    let baseX = 150 + (sectorIndex % 2) * (configGenerador.asientosPorFila * configGenerador.espacioHorizontal + espacioEntreSectores);
    let baseY = 200 + Math.floor(sectorIndex / 2) * (configGenerador.filas * configGenerador.espacioVertical + espacioEntreSectores);

    // Ajustar posición base al grid
    const snappedBase = snapPositionToGrid(baseX, baseY);
    baseX = snappedBase.x;
    baseY = snappedBase.y;

    for (let fila = 0; fila < configGenerador.filas; fila++) {
      const letraFila = String.fromCharCode(letraInicio + fila);

      // Calcular curvatura (efecto teatro) - ajustada al grid
      const curvaturaOffset = Math.round((configGenerador.curvatura / 100) * Math.pow(fila - configGenerador.filas / 2, 2) / GRID_SIZE) * GRID_SIZE;

      for (let col = 0; col < configGenerador.asientosPorFila; col++) {
        if (totalGenerados >= sector.capacidad) break;

        let x = baseX + col * configGenerador.espacioHorizontal + curvaturaOffset;
        let y = baseY + fila * configGenerador.espacioVertical;

        // Ajustar al grid si está activado
        const snappedPos = snapPositionToGrid(x, y);

        const asiento = {
          id: `${sectorId}_${letraFila}${numeroAsiento}`,
          sector_id: sectorId,
          fila: letraFila,
          numero: numeroAsiento,
          x: snappedPos.x,
          y: snappedPos.y,
          width: GRID_SIZE,
          height: GRID_SIZE,
          estado: "disponible",
          tipo: "silla",
          rotacion: configGenerador.rotacion
        };

        nuevosAsientos.push(asiento);
        totalGenerados++;
        numeroAsiento++; // Incrementar para el siguiente asiento
      }
    }

    console.log("Asientos generados:", nuevosAsientos.length, nuevosAsientos);

    // Agregar nuevos asientos (reemplazar los del sector si ya existen)
    const asientosActualizados = [...asientos.filter(a => a.sector_id !== sectorId), ...nuevosAsientos];

    console.log("Asientos totales después de generar:", asientosActualizados);

    setAsientos(asientosActualizados);

    // Actualizar formulario
    guardarMapaEnFormulario(asientosActualizados);

    Alerts({
      msg: "Success",
      title: `${totalGenerados} asientos generados para ${sector.nombre}`,
      code: "200",
      type: "success",
    });

    setMostrarModalGenerador(false);
    setSectorGenerando(null);

    // Forzar redibujado
    setTimeout(() => {
      if (ctx) {
        dibujarMapa();
      }
    }, 100);
  };

  const guardarMapaEnFormulario = (asientosActualizados = asientos) => {
    const mapaActualizado = {
      version: "2.0",
      asientos: asientosActualizados,
      escenario: escenario,
      elementosEspeciales: elementosEspeciales,
      sectores: sectores.map(s => ({
        id: s.id,
        entrada_id: s.entrada_id,
        nombre: s.nombre,
        color: s.color,
        visible: s.visible
      }))
    };

    setForm({
      ...form,
      mapa_teatro: [mapaActualizado, ""]
    });
  };

  // Guardar sitemap en la API
  const guardarSiteMapEnAPI = async () => {
    // Validar que exista un evento_id
    if (!form.id || !form.id[0]) {
      return Alerts({
        msg: "Error",
        title: "No se puede guardar el mapa sin un evento asociado. Por favor, guarda el evento primero.",
        code: "400",
        type: "error",
      });
    }

    const siteMapData = {
      version: "2.0",
      asientos: asientos,
      escenario: escenario,
      elementosEspeciales: elementosEspeciales,
      sectores: sectores.map(s => ({
        id: s.id,
        entrada_id: s.entrada_id,
        nombre: s.nombre,
        color: s.color,
        visible: s.visible
      }))
    };

    const formData = new FormData();

    // Determinar si es actualización o creación
    const isUpdate = siteMapId !== null;

    if (isUpdate) {
      // PUT/PATCH - Solo enviar site_map
      formData.append("_method", "PUT");
      formData.append("site_map", JSON.stringify(siteMapData));

      console.log("Actualizando site_map con ID:", siteMapId);
    } else {
      // POST - Enviar evento_id y site_map
      formData.append("evento_id", form.id[0]);
      formData.append("site_map", JSON.stringify(siteMapData));

      console.log("Creando nuevo site_map para evento:", form.id[0]);
    }

    const url = isUpdate ? `/site-maps/${siteMapId}` : "/site-maps";

    const response = await RestPrivateAntesala({
      url: url,
      formData: formData,
      method: "post",
      setLoading: setLoadingSave,
    });

    if (response.status === 200 || response.status === 201) {
      // Si fue una creación, guardar el ID para futuras actualizaciones
      if (!isUpdate && response.data && response.data.data && response.data.data.id) {
        setSiteMapId(response.data.data.id);
        console.log("Nuevo site_map creado con ID:", response.data.data.id);
      }

      Alerts({
        msg: "Success",
        title: isUpdate ? "Mapa de teatro actualizado exitosamente" : "Mapa de teatro guardado exitosamente",
        code: "200",
        type: "success",
      });
    } else {
      if (typeof response.data.msg === "string") {
        Alerts({
          msg: "Error",
          title: response.data.msg,
          code: "400",
          type: "error",
        });
      } else {
        Object.keys(response.data.msg).map((key) => {
          return Alerts({
            msg: "Error",
            title: response.data.msg[key][0],
            code: "400",
            type: "error",
          });
        });
      }
    }
  };

  // Manejo de eventos del canvas
  const handleCanvasClick = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left - offset.x) / zoom;
    const y = (e.clientY - rect.top - offset.y) / zoom;

    // Si hay un elemento especial para agregar
    if (elementoEspecialAAgregar) {
      const nuevoElemento = {
        id: `especial_${Date.now()}`,
        tipo: elementoEspecialAAgregar,
        x: x,
        y: y,
        width: 80,
        height: 60,
        etiqueta: elementoEspecialAAgregar.replace('_', ' ')
      };

      const nuevosElementos = [...elementosEspeciales, nuevoElemento];
      setElementosEspeciales(nuevosElementos);
      guardarMapaEnFormulario();
      setElementoEspecialAAgregar(null);

      Alerts({
        msg: "Success",
        title: "Elemento agregado correctamente",
        code: "200",
        type: "success",
      });
      return;
    }

    // Verificar click en asientos
    const asientoClickeado = asientos.find(a =>
      x >= a.x && x <= a.x + a.width &&
      y >= a.y && y <= a.y + a.height
    );

    if (asientoClickeado) {
      setElementoSeleccionado(asientoClickeado);
      setTipoSeleccionado('asiento');
      return;
    }

    // Verificar click en elementos especiales
    const elementoEspecialClickeado = elementosEspeciales.find(el =>
      x >= el.x && x <= el.x + el.width &&
      y >= el.y && y <= el.y + el.height
    );

    if (elementoEspecialClickeado) {
      setElementoSeleccionado(elementoEspecialClickeado);
      setTipoSeleccionado('especial');
      return;
    }

    // Verificar click en escenario
    if (x >= escenario.x && x <= escenario.x + escenario.width &&
        y >= escenario.y && y <= escenario.y + escenario.height) {
      setElementoSeleccionado(escenario);
      setTipoSeleccionado('escenario');
      return;
    }

    // Click en espacio vacío
    setElementoSeleccionado(null);
    setTipoSeleccionado(null);
  };

  const handleCanvasMouseDown = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left - offset.x) / zoom;
    const y = (e.clientY - rect.top - offset.y) / zoom;

    if (herramientaActiva === "seleccionar") {
      // Verificar si hizo click en un asiento para arrastrarlo
      const asientoClickeado = asientos.find(a =>
        x >= a.x && x <= a.x + a.width &&
        y >= a.y && y <= a.y + a.height
      );

      if (asientoClickeado) {
        setAsientoArrastrado(asientoClickeado);
        setOffsetAsiento({
          x: x - asientoClickeado.x,
          y: y - asientoClickeado.y
        });
        setElementoSeleccionado(asientoClickeado);
        setTipoSeleccionado('asiento');
        return;
      }

      // Verificar si hizo click en un elemento especial para arrastrarlo
      const elementoEspecialClickeado = elementosEspeciales.find(el =>
        x >= el.x && x <= el.x + el.width &&
        y >= el.y && y <= el.y + el.height
      );

      if (elementoEspecialClickeado) {
        setElementoEspecialArrastrado(elementoEspecialClickeado);
        setOffsetElementoEspecial({
          x: x - elementoEspecialClickeado.x,
          y: y - elementoEspecialClickeado.y
        });
        setElementoSeleccionado(elementoEspecialClickeado);
        setTipoSeleccionado('especial');
        return;
      }

      // Verificar si hizo click en el escenario para arrastrarlo
      if (x >= escenario.x && x <= escenario.x + escenario.width &&
          y >= escenario.y && y <= escenario.y + escenario.height) {
        setEscenarioArrastrado(true);
        setOffsetEscenario({
          x: x - escenario.x,
          y: y - escenario.y
        });
        setElementoSeleccionado(escenario);
        setTipoSeleccionado('escenario');
        return;
      }

      // Si hizo click en un espacio vacío, limpiar la selección múltiple
      setAsientosSeleccionados([]);
    } else if (herramientaActiva === "mover") {
      // Mover todo el canvas (pan)
      setIsDragging(true);
      setDragStart({ x: e.clientX - offset.x, y: e.clientY - offset.y });
    }
  };

  const handleCanvasMouseMove = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left - offset.x) / zoom;
    const y = (e.clientY - rect.top - offset.y) / zoom;

    if (asientoArrastrado && herramientaActiva === "seleccionar") {
      let nuevaPosX = x - offsetAsiento.x;
      let nuevaPosY = y - offsetAsiento.y;

      // Aplicar snap to grid
      const snappedPos = snapPositionToGrid(nuevaPosX, nuevaPosY);
      nuevaPosX = snappedPos.x;
      nuevaPosY = snappedPos.y;

      // Calcular el desplazamiento (delta)
      const deltaX = nuevaPosX - asientoArrastrado.x;
      const deltaY = nuevaPosY - asientoArrastrado.y;

      // Si el asiento arrastrado está en la selección múltiple, mover todos
      if (asientosSeleccionados.includes(asientoArrastrado.id) && asientosSeleccionados.length > 1) {
        const nuevosAsientos = asientos.map(a => {
          if (asientosSeleccionados.includes(a.id)) {
            let newX = a.x + deltaX;
            let newY = a.y + deltaY;

            // Aplicar snap a cada asiento
            const snapped = snapPositionToGrid(newX, newY);

            return {
              ...a,
              x: snapped.x,
              y: snapped.y
            };
          }
          return a;
        });

        setAsientos(nuevosAsientos);
        setAsientoArrastrado({ ...asientoArrastrado, x: nuevaPosX, y: nuevaPosY });
        setElementoSeleccionado({ ...asientoArrastrado, x: nuevaPosX, y: nuevaPosY });
      } else {
        // Arrastrar asiento individual
        const nuevosAsientos = asientos.map(a =>
          a.id === asientoArrastrado.id
            ? { ...a, x: nuevaPosX, y: nuevaPosY }
            : a
        );

        setAsientos(nuevosAsientos);
        setAsientoArrastrado({ ...asientoArrastrado, x: nuevaPosX, y: nuevaPosY });
        setElementoSeleccionado({ ...asientoArrastrado, x: nuevaPosX, y: nuevaPosY });
      }
    } else if (elementoEspecialArrastrado && herramientaActiva === "seleccionar") {
      // Arrastrar elemento especial
      let nuevaPosX = x - offsetElementoEspecial.x;
      let nuevaPosY = y - offsetElementoEspecial.y;

      // Aplicar snap to grid
      const snappedPos = snapPositionToGrid(nuevaPosX, nuevaPosY);
      nuevaPosX = snappedPos.x;
      nuevaPosY = snappedPos.y;

      const nuevosElementos = elementosEspeciales.map(el =>
        el.id === elementoEspecialArrastrado.id
          ? { ...el, x: nuevaPosX, y: nuevaPosY }
          : el
      );

      setElementosEspeciales(nuevosElementos);
      setElementoEspecialArrastrado({ ...elementoEspecialArrastrado, x: nuevaPosX, y: nuevaPosY });
      setElementoSeleccionado({ ...elementoEspecialArrastrado, x: nuevaPosX, y: nuevaPosY });
    } else if (escenarioArrastrado && herramientaActiva === "seleccionar") {
      // Arrastrar escenario
      let nuevaPosX = x - offsetEscenario.x;
      let nuevaPosY = y - offsetEscenario.y;

      // Aplicar snap to grid
      const snappedPos = snapPositionToGrid(nuevaPosX, nuevaPosY);
      nuevaPosX = snappedPos.x;
      nuevaPosY = snappedPos.y;

      const nuevoEscenario = {
        ...escenario,
        x: nuevaPosX,
        y: nuevaPosY
      };

      setEscenario(nuevoEscenario);
      setElementoSeleccionado(nuevoEscenario);
    } else if (isDragging && herramientaActiva === "mover") {
      // Mover todo el canvas
      setOffset({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      });
    }
  };

  const handleCanvasMouseUp = () => {
    if (asientoArrastrado) {
      // Guardar la posición final del asiento
      guardarMapaEnFormulario();
      setAsientoArrastrado(null);
    }
    if (elementoEspecialArrastrado) {
      // Guardar la posición final del elemento especial
      guardarMapaEnFormulario();
      setElementoEspecialArrastrado(null);
    }
    if (escenarioArrastrado) {
      // Guardar la posición final del escenario
      guardarMapaEnFormulario();
      setEscenarioArrastrado(false);
    }
    setIsDragging(false);
  };

  const handleZoom = (incremento) => {
    setZoom(prev => Math.max(0.5, Math.min(2, prev + incremento)));
  };

  const eliminarElementoSeleccionado = () => {
    if (elementoSeleccionado && tipoSeleccionado === 'asiento') {
      const nuevosAsientos = asientos.filter(a => a.id !== elementoSeleccionado.id);
      setAsientos(nuevosAsientos);
      guardarMapaEnFormulario(nuevosAsientos);
      setElementoSeleccionado(null);
      setTipoSeleccionado(null);

      Alerts({
        msg: "Success",
        title: "Asiento eliminado",
        code: "200",
        type: "success",
      });
    } else if (elementoSeleccionado && tipoSeleccionado === 'especial') {
      const nuevosElementos = elementosEspeciales.filter(el => el.id !== elementoSeleccionado.id);
      setElementosEspeciales(nuevosElementos);
      guardarMapaEnFormulario();
      setElementoSeleccionado(null);
      setTipoSeleccionado(null);

      Alerts({
        msg: "Success",
        title: "Elemento eliminado",
        code: "200",
        type: "success",
      });
    }
  };

  const cambiarEstadoAsiento = (nuevoEstado) => {
    if (elementoSeleccionado && tipoSeleccionado === 'asiento') {
      const nuevosAsientos = asientos.map(a =>
        a.id === elementoSeleccionado.id ? { ...a, estado: nuevoEstado } : a
      );
      setAsientos(nuevosAsientos);
      setElementoSeleccionado({ ...elementoSeleccionado, estado: nuevoEstado });
      guardarMapaEnFormulario(nuevosAsientos);
    }
  };

  const cambiarTipoAsiento = (nuevoTipo) => {
    if (elementoSeleccionado && tipoSeleccionado === 'asiento') {
      const nuevosAsientos = asientos.map(a =>
        a.id === elementoSeleccionado.id ? { ...a, tipo: nuevoTipo } : a
      );
      setAsientos(nuevosAsientos);
      setElementoSeleccionado({ ...elementoSeleccionado, tipo: nuevoTipo });
      guardarMapaEnFormulario(nuevosAsientos);
    }
  };

  // Función para organizar asientos de un sector en una forma específica
  const organizarAsientosPorForma = (sectorId, forma) => {
    const asientosSector = asientos.filter(a => a.sector_id === sectorId);
    if (asientosSector.length === 0) return;

    const totalAsientos = asientosSector.length;
    const espaciado = 35; // Espacio entre asientos
    const anchoAsiento = 28;
    const altoAsiento = 28;

    // Calcular posición base (centro del canvas desplazado)
    const baseX = 200;
    const baseY = 250;

    let nuevasPosiciones = [];

    switch (forma) {
      case "cuadrado": {
        // Organizar en forma de cuadrado
        const ladoCuadrado = Math.ceil(Math.sqrt(totalAsientos));
        asientosSector.forEach((asiento, index) => {
          const fila = Math.floor(index / ladoCuadrado);
          const columna = index % ladoCuadrado;
          nuevasPosiciones.push({
            ...asiento,
            x: baseX + columna * espaciado,
            y: baseY + fila * espaciado
          });
        });
        break;
      }

      case "rectangulo": {
        // Organizar en forma rectangular (más ancho que alto)
        const columnas = Math.ceil(Math.sqrt(totalAsientos * 1.5));
        const filas = Math.ceil(totalAsientos / columnas);
        asientosSector.forEach((asiento, index) => {
          const fila = Math.floor(index / columnas);
          const columna = index % columnas;
          nuevasPosiciones.push({
            ...asiento,
            x: baseX + columna * espaciado,
            y: baseY + fila * espaciado
          });
        });
        break;
      }

      case "circulo": {
        // Organizar en forma circular
        const radio = (totalAsientos * espaciado) / (2 * Math.PI);
        const centroX = baseX + radio;
        const centroY = baseY + radio;

        asientosSector.forEach((asiento, index) => {
          const angulo = (index / totalAsientos) * 2 * Math.PI;
          nuevasPosiciones.push({
            ...asiento,
            x: centroX + Math.cos(angulo) * radio,
            y: centroY + Math.sin(angulo) * radio
          });
        });
        break;
      }

      case "triangulo": {
        // Organizar en forma triangular
        let asientosColocados = 0;
        let fila = 0;

        while (asientosColocados < totalAsientos) {
          const asientosEnFila = fila + 1;
          const offset = (fila * espaciado) / 2; // Para centrar el triángulo

          for (let col = 0; col < asientosEnFila && asientosColocados < totalAsientos; col++) {
            const asiento = asientosSector[asientosColocados];
            nuevasPosiciones.push({
              ...asiento,
              x: baseX + col * espaciado - offset,
              y: baseY + fila * espaciado
            });
            asientosColocados++;
          }
          fila++;
        }
        break;
      }

      case "semicirculo": {
        // Organizar en semicírculo (como teatro tradicional)
        const radio = (totalAsientos * espaciado) / Math.PI;
        const centroX = baseX + radio;
        const centroY = baseY + radio;

        asientosSector.forEach((asiento, index) => {
          const angulo = Math.PI + (index / totalAsientos) * Math.PI;
          nuevasPosiciones.push({
            ...asiento,
            x: centroX + Math.cos(angulo) * radio,
            y: centroY + Math.sin(angulo) * radio
          });
        });
        break;
      }

      default:
        nuevasPosiciones = asientosSector;
    }

    // Actualizar posiciones de los asientos
    const asientosActualizados = asientos.map(a => {
      const nuevaPos = nuevasPosiciones.find(np => np.id === a.id);
      return nuevaPos || a;
    });

    setAsientos(asientosActualizados);
    guardarMapaEnFormulario(asientosActualizados);

    Alerts({
      msg: "Success",
      title: `Asientos reorganizados en forma de ${forma}`,
      code: "200",
      type: "success",
    });

    setMostrarModalOrganizar(false);
    setSectorOrganizando(null);
  };

  if (sectores.length === 0) {
    return (
      <div className="container-md w-100">
        <div className="border shadow-sm p-3 mb-2" style={{ borderRadius: "1rem" }}>
          <div className="alert alert-warning d-flex align-items-center">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            <div>
              <strong>No hay sectores configurados</strong>
              <br />
              <small>
                Para usar el mapa de teatro, primero debes crear entradas con el campo "Sector"
                completado en la sección "Entradas"
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid w-100 p-0">
      <div className="row g-0">
        {/* Panel de herramientas izquierdo */}
        <div className="col-md-2 border-end bg-white p-3 shadow-sm" style={{ minHeight: "700px" }}>
          <div className="mb-4">
            <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
              <i className="bi bi-tools me-2 text-primary"></i>
              Herramientas
            </h6>

            <div className="d-grid gap-2">
              <button
                className={`btn btn-sm d-flex align-items-center justify-content-start ${
                  herramientaActiva === 'seleccionar' ? 'btn-primary shadow-sm' : 'btn-outline-primary'
                }`}
                onClick={() => setHerramientaActiva('seleccionar')}
              >
                <i className="bi bi-cursor me-2"></i>
                Seleccionar
              </button>
              {herramientaActiva === 'seleccionar' && (
                <div className="alert alert-info py-2 px-2 mb-0 small border-start border-primary border-3">
                  <i className="bi bi-info-circle me-1"></i>
                  Arrastra asientos para moverlos
                </div>
              )}

              <button
                className={`btn btn-sm d-flex align-items-center justify-content-start ${
                  herramientaActiva === 'agregar_asiento' ? 'btn-primary shadow-sm' : 'btn-outline-primary'
                }`}
                onClick={() => setHerramientaActiva('agregar_asiento')}
              >
                <i className="bi bi-plus-square me-2"></i>
                Agregar asiento
              </button>

              <button
                className={`btn btn-sm d-flex align-items-center justify-content-start ${
                  herramientaActiva === 'mover' ? 'btn-primary shadow-sm' : 'btn-outline-primary'
                }`}
                onClick={() => setHerramientaActiva('mover')}
              >
                <i className="bi bi-arrows-move me-2"></i>
                Mover vista
              </button>
              {herramientaActiva === 'mover' && (
                <div className="alert alert-info py-2 px-2 mb-0 small border-start border-primary border-3">
                  <i className="bi bi-info-circle me-1"></i>
                  Arrastra para mover el mapa
                </div>
              )}

              <button
                className="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-start"
                onClick={eliminarElementoSeleccionado}
                disabled={!elementoSeleccionado || (tipoSeleccionado !== 'asiento' && tipoSeleccionado !== 'especial')}
              >
                <i className="bi bi-trash me-2"></i>
                Eliminar
              </button>
            </div>
          </div>

          <div className="mb-4">
            <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
              <i className="bi bi-grid-3x3-gap me-2 text-primary"></i>
              Configuración
            </h6>

            <div className="form-check form-switch mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                id="snapToGridSwitch"
                checked={snapToGrid}
                onChange={(e) => setSnapToGrid(e.target.checked)}
              />
              <label className="form-check-label fw-medium" htmlFor="snapToGridSwitch">
                <small>
                  <i className={`bi ${snapToGrid ? 'bi-grid-3x3' : 'bi-grid'} me-1`}></i>
                  Ajustar a cuadrícula
                </small>
              </label>
            </div>

            {snapToGrid && (
              <div className="alert alert-success py-2 px-2 mb-0 small border-start border-success border-3">
                <i className="bi bi-check-circle me-1"></i>
                Ajuste automático a {GRID_SIZE}px
              </div>
            )}

            {asientosSeleccionados.length > 0 && (
              <div className="alert alert-warning py-2 px-2 mt-3 mb-0 border-start border-warning border-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="small">
                    <i className="bi bi-check-circle-fill me-1"></i>
                    <strong>{asientosSeleccionados.length}</strong> {asientosSeleccionados.length !== 1 ? 'asientos' : 'asiento'}
                  </div>
                  <button
                    className="btn btn-sm btn-outline-warning px-2 py-0"
                    onClick={() => setAsientosSeleccionados([])}
                    title="Limpiar selección"
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
                <small className="d-block mt-1 text-muted">
                  <i className="bi bi-hand-index me-1"></i>
                  Mover todos juntos
                </small>
              </div>
            )}
          </div>

          <div className="mb-4">
            <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
              <i className="bi bi-building me-2 text-primary"></i>
              Elementos especiales
            </h6>

            <div className="d-grid gap-2">
              <button
                className={`btn btn-sm d-flex align-items-center justify-content-start ${
                  elementoEspecialAAgregar === 'escalera' ? 'btn-success shadow-sm' : 'btn-outline-success'
                }`}
                onClick={() => setElementoEspecialAAgregar(elementoEspecialAAgregar === 'escalera' ? null : 'escalera')}
              >
                <i className="bi bi-segmented-nav me-2"></i>
                Escalera
              </button>

              <button
                className={`btn btn-sm d-flex align-items-center justify-content-start ${
                  elementoEspecialAAgregar === 'ingreso' ? 'btn-success shadow-sm' : 'btn-outline-success'
                }`}
                onClick={() => setElementoEspecialAAgregar(elementoEspecialAAgregar === 'ingreso' ? null : 'ingreso')}
              >
                <i className="bi bi-box-arrow-in-right me-2"></i>
                Ingreso
              </button>

              <button
                className={`btn btn-sm d-flex align-items-center justify-content-start ${
                  elementoEspecialAAgregar === 'salida_emergencia' ? 'btn-success shadow-sm' : 'btn-outline-success'
                }`}
                onClick={() => setElementoEspecialAAgregar(elementoEspecialAAgregar === 'salida_emergencia' ? null : 'salida_emergencia')}
              >
                <i className="bi bi-door-open me-2"></i>
                Salida emerg.
              </button>

              <button
                className={`btn btn-sm d-flex align-items-center justify-content-start ${
                  elementoEspecialAAgregar === 'baño' ? 'btn-success shadow-sm' : 'btn-outline-success'
                }`}
                onClick={() => setElementoEspecialAAgregar(elementoEspecialAAgregar === 'baño' ? null : 'baño')}
              >
                <i className="bi bi-droplet me-2"></i>
                Baño
              </button>

              <button
                className={`btn btn-sm d-flex align-items-center justify-content-start ${
                  elementoEspecialAAgregar === 'pasillo' ? 'btn-success shadow-sm' : 'btn-outline-success'
                }`}
                onClick={() => setElementoEspecialAAgregar(elementoEspecialAAgregar === 'pasillo' ? null : 'pasillo')}
              >
                <i className="bi bi-arrows-vertical me-2"></i>
                Pasillo
              </button>

              {elementoEspecialAAgregar && (
                <div className="alert alert-success py-2 px-2 mb-0 small border-start border-success border-3">
                  <i className="bi bi-hand-index me-1"></i>
                  Click en mapa para colocar
                </div>
              )}
            </div>
          </div>

          <div className="mb-4">
            <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
              <i className="bi bi-eye me-2 text-primary"></i>
              Vista
            </h6>

            <div className="d-grid gap-2">
              <button
                className="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-start"
                onClick={() => setHerramientaActiva('encajar')}
              >
                <i className="bi bi-arrows-angle-expand me-2"></i>
                Encajar todo
              </button>

              <div className="btn-group btn-group-sm" role="group">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => handleZoom(-0.1)}
                  title="Alejar"
                >
                  <i className="bi bi-zoom-out"></i>
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => handleZoom(0.1)}
                  title="Acercar"
                >
                  <i className="bi bi-zoom-in"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
              <i className="bi bi-palette me-2 text-primary"></i>
              Leyenda
            </h6>
            <div className="small">
              <div className="d-flex align-items-center mb-2">
                <span className="badge me-2 rounded-circle" style={{ backgroundColor: sectores[0]?.color || "#5B9BD5", width: "18px", height: "18px" }}></span>
                <span className="fw-medium">Disponible</span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <span className="badge bg-warning me-2 rounded-circle" style={{ width: "18px", height: "18px" }}></span>
                <span className="fw-medium">Reservado</span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <span className="badge bg-danger me-2 rounded-circle" style={{ width: "18px", height: "18px" }}></span>
                <span className="fw-medium">Vendido</span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <span className="badge bg-secondary me-2 rounded-circle" style={{ width: "18px", height: "18px" }}></span>
                <span className="fw-medium">Bloqueado</span>
              </div>
            </div>
          </div>
        </div>

        {/* Canvas central */}
        <div className="col-md-7 bg-light p-4 d-flex flex-column">
          {/* Header del canvas */}
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 gap-2">
            <div>
              <h5 className="m-0 fw-bold text-primary">
                <i className="bi bi-diagram-3 me-2"></i>
                Mapa de Teatro
              </h5>
              <small className="text-muted d-block mt-1">
                <i className="bi bi-ticket-perforated me-1"></i>
                {asientos.length} asientos configurados
              </small>
            </div>
            <div className="d-flex flex-wrap gap-2">
              <button
                className="btn btn-sm btn-outline-warning"
                onClick={() => {
                  console.log("Redibujando manualmente...");
                  dibujarMapa();
                }}
                title="Redibujar el mapa"
              >
                <i className="bi bi-arrow-clockwise"></i>
              </button>
              <button
                className="btn btn-sm btn-primary"
                onClick={() => guardarMapaEnFormulario()}
              >
                <i className="bi bi-check2 me-1"></i>
                Aplicar
              </button>
              <button
                className="btn btn-sm btn-success"
                onClick={() => guardarSiteMapEnAPI()}
                disabled={loadingSave}
              >
                {loadingSave ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {siteMapId ? "Actualizando..." : "Guardando..."}
                  </>
                ) : (
                  <>
                    <i className={`bi ${siteMapId ? 'bi-arrow-repeat' : 'bi-save'} me-1`}></i>
                    {siteMapId ? "Actualizar" : "Guardar"}
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Canvas container centrado */}
          <div className="d-flex justify-content-center align-items-center flex-grow-1 mb-3">
            <div
              className="border rounded shadow-sm"
              style={{
                overflow: "hidden",
                width: "800px",
                height: "600px",
                background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)"
              }}
            >
              <canvas
                ref={canvasCallbackRef}
                onClick={handleCanvasClick}
                onMouseDown={handleCanvasMouseDown}
                onMouseMove={handleCanvasMouseMove}
                onMouseUp={handleCanvasMouseUp}
                onMouseLeave={handleCanvasMouseUp}
                style={{
                  cursor: asientoArrastrado || escenarioArrastrado || elementoEspecialArrastrado
                    ? 'grabbing'
                    : elementoEspecialAAgregar
                      ? 'crosshair'
                      : herramientaActiva === 'mover'
                        ? (isDragging ? 'grabbing' : 'grab')
                        : herramientaActiva === 'seleccionar'
                          ? 'pointer'
                          : 'default',
                  display: 'block',
                  width: '800px',
                  height: '600px',
                  backgroundColor: '#ffffff'
                }}
              />
            </div>
          </div>

          {/* Controles de zoom centrados */}
          <div className="d-flex justify-content-center align-items-center gap-3">
            <div className="btn-group shadow-sm">
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handleZoom(-0.1)}
                title="Alejar"
              >
                <i className="bi bi-dash-lg"></i>
              </button>
              <button className="btn btn-outline-secondary btn-sm disabled" style={{ minWidth: "70px" }}>
                <strong>{Math.round(zoom * 100)}%</strong>
              </button>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handleZoom(0.1)}
                title="Acercar"
              >
                <i className="bi bi-plus-lg"></i>
              </button>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setZoom(1)}
                title="Restablecer zoom"
              >
                <i className="bi bi-arrow-counterclockwise"></i>
              </button>
            </div>

            {/* Indicador de herramienta activa */}
            <div className="badge bg-secondary px-3 py-2">
              <i className={`bi ${
                herramientaActiva === 'seleccionar' ? 'bi-cursor' :
                herramientaActiva === 'mover' ? 'bi-arrows-move' :
                herramientaActiva === 'agregar_asiento' ? 'bi-plus-square' :
                'bi-hand-index'
              } me-2`}></i>
              {herramientaActiva === 'seleccionar' ? 'Seleccionar' :
               herramientaActiva === 'mover' ? 'Mover vista' :
               herramientaActiva === 'agregar_asiento' ? 'Agregar asiento' :
               elementoEspecialAAgregar ? `Agregar ${elementoEspecialAAgregar}` :
               'Modo activo'}
            </div>
          </div>
        </div>

        {/* Panel derecho - Propiedades */}
        <div className="col-md-3 border-start bg-white p-3 shadow-sm" style={{ maxHeight: "700px", overflowY: "auto" }}>
          {elementoSeleccionado && tipoSeleccionado === 'especial' ? (
            <div>
              <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
                <i className="bi bi-info-circle me-2 text-success"></i>
                Elemento Especial
              </h6>

              <div className="mb-3">
                <label className="form-label small">ID</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.id}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Tipo</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.tipo}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Etiqueta</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.etiqueta || ''}
                  onChange={(e) => {
                    const nuevosElementos = elementosEspeciales.map(el =>
                      el.id === elementoSeleccionado.id ? { ...el, etiqueta: e.target.value } : el
                    );
                    setElementosEspeciales(nuevosElementos);
                    setElementoSeleccionado({ ...elementoSeleccionado, etiqueta: e.target.value });
                    guardarMapaEnFormulario();
                  }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Posición X</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={Math.round(elementoSeleccionado.x)}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Posición Y</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={Math.round(elementoSeleccionado.y)}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Ancho</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.width}
                  onChange={(e) => {
                    const nuevoAncho = parseInt(e.target.value);
                    const nuevosElementos = elementosEspeciales.map(el =>
                      el.id === elementoSeleccionado.id ? { ...el, width: nuevoAncho } : el
                    );
                    setElementosEspeciales(nuevosElementos);
                    setElementoSeleccionado({ ...elementoSeleccionado, width: nuevoAncho });
                    guardarMapaEnFormulario();
                  }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Alto</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.height}
                  onChange={(e) => {
                    const nuevoAlto = parseInt(e.target.value);
                    const nuevosElementos = elementosEspeciales.map(el =>
                      el.id === elementoSeleccionado.id ? { ...el, height: nuevoAlto } : el
                    );
                    setElementosEspeciales(nuevosElementos);
                    setElementoSeleccionado({ ...elementoSeleccionado, height: nuevoAlto });
                    guardarMapaEnFormulario();
                  }}
                />
              </div>

              <hr />

              <button
                className="btn btn-danger btn-sm w-100"
                onClick={eliminarElementoSeleccionado}
              >
                <i className="bi bi-trash me-2"></i>
                Eliminar elemento
              </button>
            </div>
          ) : elementoSeleccionado && tipoSeleccionado === 'escenario' ? (
            <div>
              <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
                <i className="bi bi-info-circle me-2 text-dark"></i>
                Escenario
              </h6>

              <div className="alert alert-info py-2 px-2 small border-start border-info border-3">
                <i className="bi bi-hand-index me-1"></i>
                Arrastra para moverlo
              </div>

              <div className="mb-3">
                <label className="form-label small">Posición X</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={Math.round(elementoSeleccionado.x)}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Posición Y</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={Math.round(elementoSeleccionado.y)}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Ancho</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.width}
                  onChange={(e) => {
                    const nuevoAncho = parseInt(e.target.value) || 100;
                    const nuevoEscenario = { ...escenario, width: nuevoAncho };
                    setEscenario(nuevoEscenario);
                    setElementoSeleccionado(nuevoEscenario);
                    guardarMapaEnFormulario();
                  }}
                  min="50"
                  step="10"
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Alto</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.height}
                  onChange={(e) => {
                    const nuevoAlto = parseInt(e.target.value) || 50;
                    const nuevoEscenario = { ...escenario, height: nuevoAlto };
                    setEscenario(nuevoEscenario);
                    setElementoSeleccionado(nuevoEscenario);
                    guardarMapaEnFormulario();
                  }}
                  min="30"
                  step="10"
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Tipo</label>
                <select
                  className="form-select form-select-sm"
                  value={elementoSeleccionado.tipo}
                  onChange={(e) => {
                    const nuevoTipo = e.target.value;
                    const nuevoEscenario = { ...escenario, tipo: nuevoTipo };
                    setEscenario(nuevoEscenario);
                    setElementoSeleccionado(nuevoEscenario);
                    guardarMapaEnFormulario();
                  }}
                >
                  <option value="semicircular">Semicircular</option>
                  <option value="rectangular">Rectangular</option>
                </select>
              </div>
            </div>
          ) : elementoSeleccionado && tipoSeleccionado === 'asiento' ? (
            <div>
              <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
                <i className="bi bi-info-circle me-2 text-primary"></i>
                Asiento
              </h6>

              <div className="mb-3">
                <label className="form-label small">ID</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.id}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Sector</label>
                <select
                  className="form-select form-select-sm"
                  value={elementoSeleccionado.sector_id}
                  disabled
                >
                  {sectores.map(s => (
                    <option key={s.id} value={s.id}>{s.nombre}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label small">Fila</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.fila}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Número</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={elementoSeleccionado.numero}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label small">Tipo</label>
                <select
                  className="form-select form-select-sm"
                  value={elementoSeleccionado.tipo}
                  onChange={(e) => cambiarTipoAsiento(e.target.value)}
                >
                  <option value="silla">Silla</option>
                  <option value="butaca">Butaca</option>
                  <option value="banqueta">Banqueta</option>
                  <option value="accesible">Accesible</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label small">Estado</label>
                <select
                  className="form-select form-select-sm"
                  value={elementoSeleccionado.estado}
                  onChange={(e) => cambiarEstadoAsiento(e.target.value)}
                >
                  <option value="disponible">Disponible</option>
                  <option value="reservado">Reservado</option>
                  <option value="vendido">Vendido</option>
                  <option value="bloqueado">Bloqueado</option>
                </select>
              </div>

              <hr />

              <button
                className="btn btn-danger btn-sm w-100"
                onClick={eliminarElementoSeleccionado}
              >
                <i className="bi bi-trash me-2"></i>
                Eliminar asiento
              </button>
            </div>
          ) : (
            <div>
              <h6 className="mb-3 fw-bold text-dark border-bottom pb-2">
                <i className="bi bi-grid-3x3 me-2 text-primary"></i>
                Sectores
              </h6>

              {sectores.map(sector => {
                const asientosSector = asientos.filter(a => a.sector_id === sector.id).length;
                const porcentaje = Math.round((asientosSector / sector.capacidad) * 100);

                return (
                  <div key={sector.id} className="card mb-3 border-0 shadow-sm">
                    <div className="card-body p-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <h6 className="mb-1">{sector.nombre}</h6>
                          <small className="text-muted">{sector.tipo_entrada}</small>
                        </div>
                        <span
                          className="badge"
                          style={{ backgroundColor: sector.color }}
                        >
                          {asientosSector}/{sector.capacidad}
                        </span>
                      </div>

                      <div className="progress mb-2" style={{ height: "5px" }}>
                        <div
                          className="progress-bar"
                          style={{ width: `${porcentaje}%`, backgroundColor: sector.color }}
                        ></div>
                      </div>

                      <div className="d-flex gap-1 mb-2">
                        <button
                          className="btn btn-primary btn-sm flex-grow-1"
                          onClick={() => {
                            setSectorGenerando(sector);
                            setMostrarModalGenerador(true);
                          }}
                        >
                          <i className="bi bi-magic me-1"></i>
                          Generar
                        </button>
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => {
                            const nuevosSectores = sectores.map(s =>
                              s.id === sector.id ? { ...s, visible: !s.visible } : s
                            );
                            setSectores(nuevosSectores);
                          }}
                        >
                          <i className={`bi ${sector.visible ? 'bi-eye' : 'bi-eye-slash'}`}></i>
                        </button>
                      </div>

                      {asientosSector > 0 && (
                        <>
                          <button
                            className="btn btn-info btn-sm w-100 mb-2"
                            onClick={() => {
                              setSectorOrganizando(sector);
                              setMostrarModalOrganizar(true);
                            }}
                          >
                            <i className="bi bi-diagram-3 me-1"></i>
                            Organizar ({asientosSector})
                          </button>
                          <button
                            className={`btn btn-sm w-100 ${
                              asientosSeleccionados.length > 0 &&
                              asientos.filter(a => a.sector_id === sector.id && asientosSeleccionados.includes(a.id)).length === asientosSector
                                ? 'btn-success'
                                : 'btn-outline-success'
                            }`}
                            onClick={() => {
                              const asientosSectorIds = asientos
                                .filter(a => a.sector_id === sector.id)
                                .map(a => a.id);

                              // Si ya están todos seleccionados, deseleccionar
                              if (asientosSeleccionados.length > 0 &&
                                  asientosSectorIds.every(id => asientosSeleccionados.includes(id))) {
                                setAsientosSeleccionados([]);
                              } else {
                                // Seleccionar todos
                                setAsientosSeleccionados(asientosSectorIds);
                              }
                            }}
                          >
                            <i className={`bi ${
                              asientosSeleccionados.length > 0 &&
                              asientos.filter(a => a.sector_id === sector.id && asientosSeleccionados.includes(a.id)).length === asientosSector
                                ? 'bi-check-square-fill'
                                : 'bi-square'
                            } me-1`}></i>
                            {asientosSeleccionados.length > 0 &&
                             asientos.filter(a => a.sector_id === sector.id && asientosSeleccionados.includes(a.id)).length === asientosSector
                              ? 'Deseleccionar'
                              : 'Seleccionar todo'}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Modal Generador de Asientos */}
      {mostrarModalGenerador && sectorGenerando && (
        <div className="modal d-block effect-blur bg-dark bg-opacity-25" style={{ zIndex: 104 }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-magic me-2"></i>
                  Generar asientos - {sectorGenerando.nombre}
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setMostrarModalGenerador(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="alert alert-info mb-3">
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Capacidad:</strong> {sectorGenerando.capacidad} asientos
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Número de filas</label>
                    <input
                      type="number"
                      className="form-control"
                      value={configGenerador.filas}
                      onChange={(e) => setConfigGenerador({ ...configGenerador, filas: parseInt(e.target.value) })}
                      min="1"
                      max="30"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Asientos por fila</label>
                    <input
                      type="number"
                      className="form-control"
                      value={configGenerador.asientosPorFila}
                      onChange={(e) => setConfigGenerador({ ...configGenerador, asientosPorFila: parseInt(e.target.value) })}
                      min="1"
                      max="50"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Espacio horizontal (px)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={configGenerador.espacioHorizontal}
                      onChange={(e) => setConfigGenerador({ ...configGenerador, espacioHorizontal: parseInt(e.target.value) })}
                      min="25"
                      max="60"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Espacio vertical (px)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={configGenerador.espacioVertical}
                      onChange={(e) => setConfigGenerador({ ...configGenerador, espacioVertical: parseInt(e.target.value) })}
                      min="25"
                      max="60"
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label">Curvatura (efecto teatro) - {configGenerador.curvatura}%</label>
                    <input
                      type="range"
                      className="form-range"
                      value={configGenerador.curvatura}
                      onChange={(e) => setConfigGenerador({ ...configGenerador, curvatura: parseInt(e.target.value) })}
                      min="0"
                      max="100"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Letra inicial de fila</label>
                    <input
                      type="text"
                      className="form-control"
                      value={configGenerador.numeracionFila}
                      onChange={(e) => setConfigGenerador({ ...configGenerador, numeracionFila: e.target.value.toUpperCase().charAt(0) || 'A' })}
                      maxLength="1"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Número inicial</label>
                    <input
                      type="number"
                      className="form-control"
                      value={configGenerador.numeracionInicio}
                      onChange={(e) => setConfigGenerador({ ...configGenerador, numeracionInicio: parseInt(e.target.value) })}
                      min="1"
                    />
                  </div>
                </div>

                <div className="alert alert-warning">
                  <strong>Total a generar:</strong> {configGenerador.filas * configGenerador.asientosPorFila} asientos
                  {configGenerador.filas * configGenerador.asientosPorFila > sectorGenerando.capacidad && (
                    <span className="text-danger d-block mt-1">
                      ⚠ Excede la capacidad del sector ({sectorGenerando.capacidad})
                    </span>
                  )}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setMostrarModalGenerador(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => generarAsientosParaSector(sectorGenerando.id)}
                  disabled={configGenerador.filas * configGenerador.asientosPorFila > sectorGenerando.capacidad}
                >
                  <i className="bi bi-magic me-2"></i>
                  Generar asientos
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Organizar Asientos */}
      {mostrarModalOrganizar && sectorOrganizando && (
        <div className="modal d-block effect-blur bg-dark bg-opacity-25" style={{ zIndex: 104 }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-diagram-3 me-2"></i>
                  Organizar asientos - {sectorOrganizando.nombre}
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setMostrarModalOrganizar(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="alert alert-info mb-3">
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Total de asientos:</strong> {asientos.filter(a => a.sector_id === sectorOrganizando.id).length}
                </div>

                <h6 className="mb-3">Selecciona la forma de organización:</h6>

                <div className="row g-3">
                  <div className="col-md-6">
                    <div
                      className={`card h-100 ${formaOrganizacion === 'cuadrado' ? 'border-primary' : ''}`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => setFormaOrganizacion('cuadrado')}
                    >
                      <div className="card-body text-center">
                        <i className="bi bi-square display-4 mb-2"></i>
                        <h6>Cuadrado</h6>
                        <small className="text-muted">Distribución en cuadrícula perfecta</small>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div
                      className={`card h-100 ${formaOrganizacion === 'rectangulo' ? 'border-primary' : ''}`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => setFormaOrganizacion('rectangulo')}
                    >
                      <div className="card-body text-center">
                        <i className="bi bi-window display-4 mb-2"></i>
                        <h6>Rectángulo</h6>
                        <small className="text-muted">Distribución más ancha que alta</small>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div
                      className={`card h-100 ${formaOrganizacion === 'circulo' ? 'border-primary' : ''}`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => setFormaOrganizacion('circulo')}
                    >
                      <div className="card-body text-center">
                        <i className="bi bi-circle display-4 mb-2"></i>
                        <h6>Círculo</h6>
                        <small className="text-muted">Distribución circular completa</small>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div
                      className={`card h-100 ${formaOrganizacion === 'semicirculo' ? 'border-primary' : ''}`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => setFormaOrganizacion('semicirculo')}
                    >
                      <div className="card-body text-center">
                        <i className="bi bi-badge-ar display-4 mb-2"></i>
                        <h6>Semicírculo</h6>
                        <small className="text-muted">Estilo teatro tradicional</small>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div
                      className={`card h-100 ${formaOrganizacion === 'triangulo' ? 'border-primary' : ''}`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => setFormaOrganizacion('triangulo')}
                    >
                      <div className="card-body text-center">
                        <i className="bi bi-triangle display-4 mb-2"></i>
                        <h6>Triángulo</h6>
                        <small className="text-muted">Distribución piramidal</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="alert alert-warning mt-3">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  Esta acción reorganizará todos los asientos del sector <strong>{sectorOrganizando.nombre}</strong>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setMostrarModalOrganizar(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => organizarAsientosPorForma(sectorOrganizando.id, formaOrganizacion)}
                >
                  <i className="bi bi-check2-circle me-2"></i>
                  Aplicar organización
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapaTeatro;
